module.exports = __webpack_public_path__ + "static/media/asagi-happy.6dd69661.png";